import { useEffect, useState } from "react";
import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import { ServerStatus, connectionActive } from "../serverStatus";
import { palette } from "../theme";

interface SetupCardProps {
  serverStatus: ServerStatus;
  toggleLive: (liveId: string, videoId: string, inventorySize: number) => void;
  onResume: () => void;
}
export function SetupCard({ serverStatus, toggleLive, onResume }: SetupCardProps): JSX.Element {
  const [video, setVideo] = useState("");
  const [liveId, setLiveId] = useState(() => new Date().toISOString());
  const [items, setItems] = useState(100);
  const active = serverStatus.status === "LIVE";
  const interrupted = serverStatus.connection?.state === "INTERRUPTED";
  useEffect(() => {
    if (serverStatus.connection?.liveVideoId) setVideo(serverStatus.connection.liveVideoId);
    if (serverStatus.connection?.liveId) setLiveId(serverStatus.connection.liveId);
  }, [serverStatus.connection?.sessionId, serverStatus.connection?.liveVideoId, serverStatus.connection?.liveId]);
  return <Box sx={{ p: 2.5, border: "1px solid " + palette.border, borderRadius: 2, bgcolor: palette.surface }}>
    <Typography variant="h3" sx={{ mb: 2 }}>Phát trực tiếp trên Trang Facebook</Typography>
    <Box component="form" onSubmit={event => { event.preventDefault(); toggleLive(liveId, "", items); }}
      sx={{ display: "flex", gap: 2, flexWrap: "wrap", alignItems: "flex-start" }}>
      <Typography sx={{ flex: 1, minWidth: 240, pt: 1 }} color="text.secondary">
        Phần mềm sẽ tự tìm livestream đang phát của Page đã chọn.
        {video && ` Video ID: ${video}`}
      </Typography>
      <Button type="submit" variant="contained"
        disabled={!connectionActive(serverStatus) || (!active && (!liveId.trim() || !Number.isInteger(items) || items < 0 || items > 10000))}>
        {serverStatus.requestPending ? "Đang tìm live…" : active ? "Dừng" : "Tự tìm livestream"}
      </Button>
    </Box>
    {interrupted && <Alert severity="warning" sx={{ mt: 2 }} action={
      <Button color="inherit" size="small" disabled={!connectionActive(serverStatus)} onClick={onResume}>Nối lại</Button>
    }>Máy chủ đã khởi động lại. Bình luận cũ vẫn được giữ; nhấn Nối lại để tiếp tục theo dõi trực tiếp.</Alert>}
    <Box component="details" id="sales-setup" sx={{ mt: 1 }}>
      <Box component="summary" sx={{ cursor: "pointer", color: palette.inkSoft }}>Thiết lập bán hàng</Box>
      <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
        <TextField label="Live ID" value={liveId} disabled={active} onChange={event => setLiveId(event.target.value)} />
        <TextField label="Số mặt hàng" type="number" value={items} disabled={active}
          onChange={event => setItems(Number(event.target.value))} />
      </Box>
    </Box>
    {serverStatus.requestError && <Alert severity="error" sx={{ mt: 2 }}>{serverStatus.requestError}</Alert>}
  </Box>;
}
